export const nebraska = {
  "31000": "Nebraska",
  "31001": "Adams County",
  "31003": "Antelope County",
  "31005": "Arthur County",
  "31007": "Banner County",
  "31009": "Blaine County",
  "31011": "Boone County",
  "31013": "Box Butte County",
  "31015": "Boyd County",
  "31017": "Brown County",
  "31019": "Buffalo County",
  "31021": "Burt County",
  "31023": "Butler County",
  "31025": "Cass County",
  "31027": "Cedar County",
  "31029": "Chase County",
  "31031": "Cherry County",
  "31033": "Cheyenne County",
  "31035": "Clay County",
  "31037": "Colfax County",
  "31039": "Cuming County",
  "31041": "Custer County",
  "31043": "Dakota County",
  "31045": "Dawes County",
  "31047": "Dawson County",
  "31049": "Deuel County",
  "31051": "Dixon County",
  "31053": "Dodge County",
  "31055": "Douglas County",
  "31057": "Dundy County",
  "31059": "Fillmore County",
  "31061": "Franklin County",
  "31063": "Frontier County",
  "31065": "Furnas County",
  "31067": "Gage County",
  "31069": "Garden County",
  "31071": "Garfield County",
  "31073": "Gosper County",
  "31075": "Grant County",
  "31077": "Greeley County",
  "31079": "Hall County",
  "31081": "Hamilton County",
  "31083": "Harlan County",
  "31085": "Hayes County",
  "31087": "Hitchcock County",
  "31089": "Holt County",
  "31091": "Hooker County",
  "31093": "Howard County",
  "31095": "Jefferson County",
  "31097": "Johnson County",
  "31099": "Kearney County",
  "31101": "Keith County",
  "31103": "Keya Paha County",
  "31105": "Kimball County",
  "31107": "Knox County",
  "31109": "Lancaster County",
  "31111": "Lincoln County",
  "31113": "Logan County",
  "31115": "Loup County",
  "31117": "McPherson County",
  "31119": "Madison County",
  "31121": "Merrick County",
  "31123": "Morrill County",
  "31125": "Nance County",
  "31127": "Nemaha County",
  "31129": "Nuckolls County",
  "31131": "Otoe County",
  "31133": "Pawnee County",
  "31135": "Perkins County",
  "31137": "Phelps County",
  "31139": "Pierce County",
  "31141": "Platte County",
  "31143": "Polk County",
  "31145": "Red Willow County",
  "31147": "Richardson County",
  "31149": "Rock County",
  "31151": "Saline County",
  "31153": "Sarpy County",
  "31155": "Saunders County",
  "31157": "Scotts Bluff County",
  "31159": "Seward County",
  "31161": "Sheridan County",
  "31163": "Sherman County",
  "31165": "Sioux County",
  "31167": "Stanton County",
  "31169": "Thayer County",
  "31171": "Thomas County",
  "31173": "Thurston County",
  "31175": "Valley County",
  "31177": "Washington County",
  "31179": "Wayne County",
  "31181": "Webster County",
  "31183": "Wheeler County",
  "31185": "York County",
};
